export const PERSIST_LAST_SUBSCRIPTION = 'dt/variables/PERSIST_LAST_SUBSCRIPTION';
export const ADD_LAST_SUBSCRIPTION = 'dt/variables/ADD_LAST_SUBSCRIPTION';
export const RECEIVE_LAST_SUBSCRIPTIONS = 'dt/variables/RECEIVE_LAST_SUBSCRIPTIONS';
export const ADD_LAST_SUBSCRIPTIONS = 'dt/variables/ADD_LAST_SUBSCRIPTIONS';
export const REMOVE_LAST_SUBSCRIPTIONS = 'dt/variables/REMOVE_LAST_SUBSCRIPTIONS';
export const FETCH_LAST_VARIABLE_DATA = 'dt/variables/FETCH_LAST_VARIABLE_DATA';
export const RECEIVE_LAST_VALUES = 'dt/variables/RECEIVE_LAST_VALUES';
export const VARIABLES_IMPORTED_AT = 'dt/variables/VARIABLES_IMPORTED_AT';
export const SET_VARIABLES_LAST_POLLING = 'dt/variables/SET_VARIABLES_LAST_POLLING';
export const DOWNLOAD_VARIABLES_TEMPLATE = 'dt/variables/DOWNLOAD_VARIABLES_TEMPLATE';
export const UPLOAD_VARIABLES_EXCEL_SHEET = 'dt/variables/UPLOAD_VARIABLES_EXCEL_SHEET';
export const VARIABLE_IMPORT_ERRORS = 'dt/variables/VARIABLE_IMPORT_ERRORS';
export const FETCH_EXTENDED_SERIES_DATA = 'dt/variables/FETCH_EXTENDED_SERIES_DATA';
export const STOP_FETCH_EXTENDED_SERIES_DATA = 'dt/variables/STOP_FETCH_EXTENDED_SERIES_DATA';

export const addSubscriptions = (panelId, variableIds) => ({
  type: ADD_LAST_SUBSCRIPTIONS,
  panelId,
  variableIds,
});

export const removeSubscriptions = (panelId, variableIds) => ({
  type: REMOVE_LAST_SUBSCRIPTIONS,
  panelId,
  variableIds,
});

export const receiveLastValues = (values) => ({
  type: RECEIVE_LAST_VALUES,
  values,
});

export const refreshLastVariableData = () => ({
  type: FETCH_LAST_VARIABLE_DATA,
});

export const setVariablesImportedAt = (importedAt = 0) => ({
  type: VARIABLES_IMPORTED_AT,
  variablesImportedAt: importedAt,
});

export const downloadVariablesExcel = (site) => ({
  type: DOWNLOAD_VARIABLES_TEMPLATE,
  site,
});

export const uploadVariablesExcel = (file, siteId, org, template) => ({
  type: UPLOAD_VARIABLES_EXCEL_SHEET,
  file,
  siteId,
  org,
  template,
});

export const setImportErrors = (errors) => ({
  type: VARIABLE_IMPORT_ERRORS,
  errors,
});

export const fetchExtendedSeriesData = (
  { variables, aggregation, granularity, timeRange, startDate, endDate },
  callback
) => ({
  type: FETCH_EXTENDED_SERIES_DATA,
  variables,
  aggregation,
  interval: granularity,
  timeRange,
  startDate,
  endDate,
  callback,
});

export const stopFetchExtendedSeriesData = () => ({ type: STOP_FETCH_EXTENDED_SERIES_DATA });
